import React, { useState } from 'react';
import styled from 'styled-components';
import BaseButton from './BaseButton';

import { Colors } from '../../../../scss/common/style';

interface Props {
  size?: 'sm' | 'lg';
  onClick?: () => void;
  title?: string;
  isSubmitting?: boolean;
  active?: boolean;
  disabled?: boolean;
  type?: 'button' | 'reset' | 'submit';
  underline?: boolean;
}

export default function LinkButton({
  onClick,
  title,
  isSubmitting = false,
  active = false,
  disabled = false,
  type,
  underline = false,
}: Props): JSX.Element {
  return (
    <StyledButton>
      <BaseButton
        type={type}
        title={title}
        onClick={onClick}
        isSubmitting={isSubmitting}
        disabled={disabled}
        active={active}
        underline={underline}
        variant="link"
      />
    </StyledButton>
  );
}

const StyledButton = styled.div`
  button {
    background-color: transparent !important;
    padding: 0px;
    color: ${Colors.newOrage}!important;
    &:hover {
      color: ${Colors.darkRed}!important;
    }
    &:active {
      color: ${Colors.darkBrown} !important;
    }
    text-decoration: ${(props): boolean => (props.underline ? 'underline' : '')}!important;
  }
`;
